// extracted by mini-css-extract-plugin
module.exports = {"navLink":"xm","linkButton":"xn","navLinkWhileSearching":"xo"};